<template>
    <b-list-group-item class="simple-list-view-item interactive">
        <i class="drag-handle fas fa-grip-dots-vertical fa-fw mr-1 display-hover" :title="'Drag to reorder|Glissez pour modifier l\'ordre'|tr"/>
        <i class="fas fa-fw mr-1 hide-hover" :class="glyph"/>
        <slot name="name">
            <span class="name">
                {{label|tr}}
            </span>
        </slot>
        <slot></slot>
        <template v-if="!readonly">
            <b-btn v-if="showDuplicate" @click.stop="$emit('duplicate')" variant="white" class="btn-duplicate display-hover" :title="'Duplicate|Dupliquer'|tr" v-b-tooltip>
                <i class="fas fa-copy"/>
            </b-btn>
            <e-button-confirm v-if="showDelete" @click="$emit('delete')" variant="danger" class="btn-delete display-hover" button-class="btn-danger"
                              confirm-title="Delete?|Supprimer?" button-text="Delete|Supprimer" :icon="getPublicIcon('trash')" :title="'Delete|Supprimer'|tr" v-b-tooltip>
                <i class="fas fa-trash"/>
            </e-button-confirm>
        </template>
    </b-list-group-item>
</template>

<script>
// simple-list-view-item #hot-reload-debug
import EButtonConfirm from "@vue-components/components/e-button-confirm.vue";

export default {
    name: `simple-list-view-item`,
    components: {EButtonConfirm},
    props: {
        glyph: {type: String},
        label: {type: String},
        showDuplicate: {type: Boolean},
        showDelete: {type: Boolean},
        readonly: {type: Boolean}
    }
}
</script>

<style lang="scss" scoped>
.simple-list-view-item {
    padding: 5px 5px 5px 10px;
    display: flex;
    align-items: center;
    position: relative;
    height: 44px;

    .btn-delete {
        position: absolute;
        right: 7px;
        top: 5px;
    }

    .btn-duplicate {
        position: absolute;
        right: 45px;
        top: 5px;
    }
}
</style>
